'use client';

import Image from 'next/image';
import { getIsMobile } from '@/libs/utils/user';
import * as S from './styles';

interface HeroProps {
  onOpenContact?: (isMobile: boolean) => void;
}

const Hero = ({ onOpenContact }: HeroProps) => {
  const baseImageUrl = process.env.NEXT_PUBLIC_BASE_IMAGE_URL;
  const isMobile = getIsMobile();
  const description = isMobile
    ? '실시간 모니터링, 악성 리뷰 법적 조치\n전문가 응답까지 원스톱으로\n모든 과정은 검증된 전문가가 체계적으로 수행합니다.'
    : '실시간 모니터링, 악성 리뷰 법적 조치, 전문가 응답까지 원스톱으로\n모든 과정은 검증된 전문가가 체계적으로 수행합니다.';

  return (
    <S.Container>
      <S.Inner>
        <S.Content>
          <S.Title>
            리뷰웍스팀이 복잡한
            <br />
            리뷰 운영 업무를 함께해요
          </S.Title>
          <S.Description>{description}</S.Description>
          <S.Btn_CTA onClick={() => onOpenContact?.(isMobile)}>리뷰매니저 상담 신청</S.Btn_CTA>
        </S.Content>
        <S.AIImage>
          <Image src={baseImageUrl + `/landing/enterprise/hero-ai-${isMobile ? 'm' : 'pc'}.png?v=1.0`} alt={'ai 이미지'} fill sizes="100%" className="object-contain" priority loading="eager" />
        </S.AIImage>
      </S.Inner>
    </S.Container>
  );
};

export default Hero;
